import type { AxiosInstance } from 'axios';
import type { ApiResponse } from '@/types';
import type { NewLoginedData, NewLoginPayload, NewLogoutPayload } from '@/types/api/login.type';

export default function loginApi(ai: AxiosInstance) {
  function login<D extends NewLoginedData, R extends ApiResponse<D>>(payload: NewLoginPayload) {
    return ai.post<R>('/api/v2/login', payload, { headers: { 'Content-Type': 'multipart/form-data' } });
  }

  function logout<D extends Record<string, never>, R extends ApiResponse<D>>(payload: NewLogoutPayload) {
    return ai.post<R>('/api/v2/logout', payload, { headers: { 'Content-Type': 'multipart/form-data' } });
  }

  return {
    login,
    logout
  };
}